import { render } from "./AdminMediaUpload.vue?vue&type=template&id=c266a0d0&scoped=true&ts=true"
import script from "./AdminMediaUpload.vue?vue&type=script&lang=ts"
export * from "./AdminMediaUpload.vue?vue&type=script&lang=ts"

import "./AdminMediaUpload.vue?vue&type=style&index=0&id=c266a0d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c266a0d0"]])

export default __exports__